import Vue from 'vue'
import Router from 'vue-router'
import beforeEach from './beforeEach'
import afterEach from './afterEach'
import login from '@/views/login'
import modules from '@/views/modules'
import nologin from '@/views/401'
Vue.use(Router)

const router =  new Router({
  routes: [
    ...login,
    ...modules,
    ...nologin
  ]
})

router.beforeEach(beforeEach);
router.afterEach(afterEach);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js